// import React from "react";
// import { Modal } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { bindActionCreators } from "redux";
// import { Actions } from "../../../Action";
// import { amendHeaders } from "../../../API/api";
// import "./AFModalsStyles.css";
// import { DOWNLOAD_HEADERS } from "../../../API/url";
// import { toast } from "react-toastify";

// export function GenerteQModal() {
//   const dispatch = useDispatch();
//   const { ingestedrefreshData, advanceFilterModalToggle } = bindActionCreators(
//     Actions,
//     dispatch
//   );
//   const modalState = useSelector((state) => state.domain);
//   const drawerState = useSelector((state) => state.drawer);
//   const followUpToast = (message) => {
//     return (
//         <>
//             <p style={{ fontSize: "12px"}}>
//                 {message}
//             </p>
//         </>
//     );
// };
//   const onClickSubmit = (key) => {
//     if (key === "csv" || key === "both") {
//       let url = DOWNLOAD_HEADERS(drawerState.tableDataCurrent.soId, "download");
//       window.open(process.env.REACT_APP_MY_ENV_VARIABLE+'/'+url, "_blank");
//     }
//     if (key === "header" || key === "both") {
//       amendHeaders(drawerState.tableDataCurrent.soId).then((res) => {
//         toast.success(followUpToast('Headers have been amended successfully.'), {
//           position: toast.POSITION.TOP_RIGHT,
//         });
//         ingestedrefreshData(3);
//       });
//     }
//     advanceFilterModalToggle({ bool: false, value: "" });
//   };
//   return (
//     <>
//       <div>
//         <Modal
//           show={modalState.modalState}
//           size={"md"}
//           centered={true}
//           onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
//         >
//           <Modal.Header
//             closeButton
//             closeVariant="white"
//             className="modalHeaders"
//           >
//             <Modal.Title style={{ fontSize: "17px" }}>
//               <span
//                 style={{ fontSize: "20px" }}
//                 className="fa  fa-file-text"
//               ></span>
//               &nbsp; Generate Questions
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ paddingBottom: "0px" }}>
//             <div>
//               <span style={{ fontSize: "15px" }}>
//                 How do you want to export questions?
//               </span>
//             </div>
//             <div
//               className="mt-2 mb-2"
//               style={{ display: "flex", justifyContent: "center" }}
//             >
//               <button
//                 className="rerouteBtn"
//                 style={{ fontSize: "12px" }}
//                 onClick={() => onClickSubmit("csv")}
//               >
//                 CSV Download
//               </button>
//               <button
//                 disabled={drawerState.tableDataCurrent.headersAmended}
//                 className="rerouteBtn"
//                 style={{ fontSize: "12px" }}
//                 onClick={() => onClickSubmit("header")}
//               >
//                 Amend Headers
//               </button>
//               &nbsp;
//               <button
//                 disabled={drawerState.tableDataCurrent.headersAmended}
//                 style={{ fontSize: "12px", width: "100px" }}
//                 className="rerouteBtn"
//                 onClick={() => onClickSubmit("both")}
//               >
//                 Both
//               </button>
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>
//     </>
//   );
// }

import React from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { amendHeaders } from "../../../API/api";
import "./AFModalsStyles.css";
import { DOWNLOAD_HEADERS } from "../../../API/url";
import { toast } from "react-toastify";
const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};

const textStyles1 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  textAlign: "left",
  display: "flex",
  justifyContent: "center",
  width: "100%"


};
export function GenerteQModal() {
  const dispatch = useDispatch();
  const { ingestedrefreshData, advanceFilterModalToggle } = bindActionCreators(
    Actions,
    dispatch
  );

  const modalState = useSelector((state) => state.domain);
  const drawerState = useSelector((state) => state.drawer);

  const followUpToast = (message) => (
    <p style={{ fontSize: "12px" }}>{message}</p>
  );

  const onClickSubmit = (key) => {
    if (key === "csv" || key === "both") {
      let url = DOWNLOAD_HEADERS(drawerState.tableDataCurrent.soId, "download");
      window.open(
        process.env.REACT_APP_MY_ENV_VARIABLE + "/" + url,
        "_blank"
      );
    }
    if (key === "header" || key === "both") {
      amendHeaders(drawerState.tableDataCurrent.soId).then(() => {
        toast.success(
          followUpToast("Headers have been amended successfully."),
          { position: toast.POSITION.TOP_RIGHT }
        );
        ingestedrefreshData(3);
      });
    }
    advanceFilterModalToggle({ bool: false, value: "" });
  };

  return (
    <Modal
      show={modalState.modalState}
      size="md"
      centered
      onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
    >
      {/* <ModalHeader closeButton>
        <ModalTitle style={modalTitleStyle}>
          <h5
            style={{
              wordBreak: "break-word",
              overflowWrap: "break-word",
              display: "flex",
              alignItems: "center",
            }}
          >
            <i
              className="fa fa-book"
              style={{ paddingRight: "7px", fontSize: "16px" }}
            ></i>
           Generate Questions
          </h5>
        </ModalTitle>
      </ModalHeader> */}
      <Modal.Header closeButton>
        <Modal.Title style={modalTitleStyle}>
          <span>
            <i class="fa fa-book" aria-hidden="true"> </i> &nbsp;&nbsp;Generate Questions
          </span>


        </Modal.Title>
      </Modal.Header>
      {/* <Modal.Header
        closeButton
        closeVariant="white"
        className="modalHeaders"
      >
        <Modal.Title style={modalTitleStyle}>
          <span
            style={{ fontSize: "20px" }}
            className="fa fa-file-text"
          ></span>
          &nbsp; Generate Questions
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body style={{ paddingBottom: "0px" }}>
        <div>
          <span style={textStyles1}>

            How do you want to export questions?
          </span>
        </div>
        <div
          className="mt-2 mb-2"
          style={{ display: "flex", justifyContent: "center", gap: "10px" }}
        >
          <button
            style={{
              padding: '8px 12px 8px 12px',
              borderRadius: '6px',
              fontSize: '14px',
              lineHeight: '24px',
              fontWeight: 400,
              boxShadow: ' 0px 1px 2px 0px #1018280D',
              // color: '#2A364A',
              color: "white",
              border: '1px solid  #fff',
              height: '40px',
              minWidth: '88px',
              // background: " #F6F7F8",
              marginBottom: '14px',
              fontWeight: 400,
              border: " 1px solid #E0E2E6",
              cursor: "pointer",
              background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
              //  font-weight: 400;			
            }}
            onClick={() => onClickSubmit("csv")}
          >
            CSV Download
          </button>

          <button
            disabled={drawerState.tableDataCurrent.headersAmended}
            style={{
              padding: '8px 12px 8px 12px',
              borderRadius: '6px',
              fontSize: '14px',
              lineHeight: '24px',
              fontWeight: 400,
              boxShadow: ' 0px 1px 2px 0px #1018280D',
              color: '#2A364A',
              border: '1px solid  #fff',
              height: '40px',
              minWidth: '88px',
              background: " #F6F7F8",
              //  background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
              marginBottom: '14px',
              fontWeight: 400,
              border: " 1px solid #E0E2E6",
              cursor: drawerState.tableDataCurrent.headersAmended ? "not-allowed" : "pointer"
              //  font-weight: 400;			
            }}
            onClick={() => onClickSubmit("header")}
          >
            Amend Headers
          </button>

          <button
            disabled={drawerState.tableDataCurrent.headersAmended}
            style={{
              padding: '8px 12px 8px 12px',
              borderRadius: '6px',
              fontSize: '14px',
              lineHeight: '24px',
              fontWeight: 400,
              boxShadow: ' 0px 1px 2px 0px #1018280D',
              color: '#2A364A',
              border: '1px solid  #fff',
              height: '40px',
              minWidth: '88px',
              background: " #F6F7F8",
              // background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
              marginBottom: '14px',
              fontWeight: 400,
              border: " 1px solid #E0E2E6",
              cursor: drawerState.tableDataCurrent.headersAmended ===true ? "not-allowed" : "pointer"
              //  font-weight: 400;			
            }}
            // style={{ fontSize: "12px", width: "100px" }}
            onClick={() => onClickSubmit("both")}
          >
            Both
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

